import { getRecursiveChildren } from '../../propertyWizard/steps/utils/getInitialValues';
import * as yup from 'yup';
import modules from './modules';

const {
  surface: surfaceSchema,
  antiquity: antiquitySchema,
  price: priceSchema,
  description: descriptionSchema
} = modules;

export const generateSchema = (characteristics, propertyType) => {
  const onlyChildrenArr = getRecursiveChildren(characteristics);

  const schemaObj = {};
  const characteristicsSchema = {};

  onlyChildrenArr.forEach(({ type }) => {
    switch (type) {
      case 'totalSurface':
      case 'coveredSurface':
      case 'uncoveredSurface':
      case 'semiCoveredSurface':
      case 'exclusiveSurface':
        if (!schemaObj.surface)
          schemaObj.surface = surfaceSchema(
            propertyType !== 10 && propertyType !== 4
          );
        break;

      case 'antiquity':
        if (!schemaObj.antiquity) schemaObj.antiquity = antiquitySchema;
        break;

      case 'price':
      case 'expenses':
        if (!schemaObj.price) schemaObj.price = priceSchema;
        break;

      case 'description':
        if (!schemaObj.description) schemaObj.description = descriptionSchema;
        break;

      case 'laundry':
      case 'balcony':
      case 'yard':
      case 'rooftop':
      case 'garages':
        if (!characteristicsSchema[type])
          characteristicsSchema[type] = modules[type];
        break;
      case 'buildingStage':
      case 'buildingLocationInBlock':
      case 'buildingCeilingHeight':
      case 'buildingAntiquity':
      default:
        break;
    }
  });

  if (Object.keys(characteristicsSchema).length) {
    schemaObj.characteristics = yup.object().shape(characteristicsSchema);
  }

  const schema = yup.object().shape(schemaObj);

  return schema;
};
